type FormatPriceParameters = {
  value: number;
  countryCode: string;
  currencyCode: string;
};

export const formatPrice = ({
  value,
  countryCode,
  currencyCode,
}: FormatPriceParameters) => {
  return new Intl.NumberFormat(countryCode, {
    style: "currency",
    currency: currencyCode,
  }).format(Number(value));
};
